// extracted by mini-css-extract-plugin
export default {"card":"Card_card__6iwld","body":"Card_body__DGN5x","image":"Card_image__+6Z3f","indicator":"Card_indicator__QPvVE","title":"Card_title__uRzjZ"};